import React, { useState } from "react";
import "./Jobs.css";
import thereBottle from "../assets/images/there-bottle.png";
import Accordion from "../components/Accordion";
import ApplicationForm from "../components/ApplicationForm";

const Jobs = () => {
  const jobs = [
    {
      title: "sound-designer",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,",
    },
    {
      title: "VFX",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      title: "composer",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      title: "colorist",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      title: "editor",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
  ];

  const [selectedJob, setSelectedJob] = useState(null);

  const onClickHandler = (job) => {
    console.log("Selected job:", job);
    setSelectedJob(job);
  };

  return (
    <section className="jobs">
      <img
        src={thereBottle}
        alt="illustration"
        className="jobs__image"
        height={280}
      />
      <div className="jobs__content">
        <h2>Choisis ton poste</h2>
        <Accordion items={jobs} onClickHandler={onClickHandler} />
      </div>
      <div className="jobs__form">
        {selectedJob && (
          <>
            <h2>Remplis tes infos</h2>
            <h5>
              pour nous rejoindre en tant que <span>{selectedJob}</span>
            </h5>
          </>
        )}
        <ApplicationForm job={selectedJob} />
      </div>
    </section>
  );
};

export default Jobs;
